/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/movie/overview/features.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'movie/overview/features', exports: {} };
const exports = module.exports;



import { Fandango as Fandango_movieDetails } from '@take-2/fd-modules/splits/require-core';

const { movieDetails: { id: movieID } } = Fandango_movieDetails;


import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



import { fd_url_manager as links } from '@take-2/fd-modules/splits/require-core';



import { Splide as Splide } from '@take-2/fd-modules/splits/require-core';



import { swig as swig } from '@take-2/fd-modules/splits/require-core';



import { Fandango_xhr as xhr } from '@take-2/fd-modules/splits/require-core';



const SPINNER_DELAY = 1000


const ITEM_LIMIT = 50


let spinnerTimeout


const Selectors = {
    SLIDER: '#features-splide-slider',
    CONTAINER: '#features-container',
    SPINNER: '#features-slider-spinner',
    WALL: '#features-slider-wall'
}


const Styles = {
    HIDE: 'hide',
    HIDE_SLIDER: 'features__slider-wrap--loading'
}
function hideSpinner() {
    clearTimeout(spinnerTimeout);
    const spinner = document.querySelector(Selectors.SPINNER);
    spinner.classList.add(Styles.HIDE);
}
function showSpinner() {
    const spinner = document.querySelector(Selectors.SPINNER);
    spinnerTimeout = setTimeout(() => spinner.classList.remove(Styles.HIDE), SPINNER_DELAY);
}
function onGetDone(data) {
    hideSpinner();
    if (!data || data.isEmpty) {
        return document.querySelector(Selectors.CONTAINER).classList.add(Styles.HIDE);
    }
    document.querySelector(Selectors.WALL).innerHTML = swig.render('_splideFeatures', data);
    document.querySelector(Selectors.SLIDER).classList.remove(Styles.HIDE_SLIDER);
    new Splide(Selectors.SLIDER, {
        fixedWidth: '294px',
        fixedHeight: '217px',
        slideFocus: false,
        pagination: false,
    }).mount();
}
function onGetFail(err) {
    debugLog.warn('Features API Fail', err);
}
function init() {
    showSpinner();
    xhr.ajax({
        method: 'GET',
        url: links.napiFeatures({ id: movieID, page: 1 }, { pageSize: ITEM_LIMIT }),
    })
        .done(onGetDone)
        .fail(onGetFail);
}
export default {
    init
};
